import axios from 'axios';
import moment from 'moment';
import { getCookieByName } from '../../utils';
import { DEFAULT_LANG } from '../../const/lang';


const state = {
  errors: [],
  helpText: '',
  currentPushTick: moment().utc(),
};

const getters = {
  api() {
    return {
      contacts() {
        return `${process.env.server_url}/contacts/${getCookieByName('accessToken')}`;
      },
      contactsGroups() {
        return `${process.env.server_url}/contacts/groups/${getCookieByName('accessToken')}`;
      },
      contactPhoto() {
        return `${process.env.server_url}/contact/photo/${getCookieByName('accessToken')}`;
      },
      users: `${process.env.server_url}/users`,
      remoteSinglePusher: `${process.env.server_url}/remote/push`,
      remoteLoginPusher: `${process.env.server_url}/remote/push/login`,
    };
  },
  pushTick() {
    return state.currentPushTick;
  },
};

const actions = {
  async setLang({ commit }, data) {
    const value = data.value;
    if (value in data.ctx.$i18n.messages) {
      commit('SAVE_LANG', data);
    } else {
      let res = await import(`../../i18n/langs/${value}.json`);
      if (Object.keys(res).length === 0) {
        const LANG = DEFAULT_LANG.symbol;
        res = await import(`../../i18n/langs/${LANG}.json`);
      }
      data.ctx.$i18n.setLocaleMessage(value, res);
      commit('SAVE_LANG', data);
    }
  },
  async deleteUser({ dispatch, rootState, rootGetters }) {
    const uid = rootState.user.data.uid;
    await axios.delete(`${rootGetters.api.users}/auth/`, { headers: { uid } });
    await dispatch('signOut');
  },
  saveHelpText({ commit }, data) {
    commit('SAVE_HELP_TEXT', data);
  },
  renewPushTick({ commit }) {
    commit('RENEW_PUSH_TICK');
  },
  resetPushTick({ commit }) {
    commit('RESET_PUSH_TICK');
  },
};

const mutations = {
  ADD_ERROR(state, payload) {
    state.errors.push(payload);
  },
  SAVE_LANG(state, payload) {
    /* eslint-disable no-param-reassign */
    payload.ctx.$i18n.locale = payload.value;
  },
  SAVE_HELP_TEXT(state, payload) {
    state.helpText = payload;
  },
  RENEW_PUSH_TICK(state) {
    state.currentPushTick = moment().utc().add(process.env.PUSH_TIMER_TICK, 'milliseconds');
  },
  RESET_PUSH_TICK(state) {
    state.currentPushTick = moment().utc();
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/commons.js